module.exports = __webpack_public_path__ + "img/almost-done-th.999b3f0.png";